module.exports = __webpack_public_path__ + "static/media/8.ff760f45.JPG";